export const STATUS_MAPPING = {
  TO_BE_PROCESSED: "Upload Pending",
  PROCESSING: "Processing",
  EXPORTING: "Exporting",
  EXPORTED: "Ready for review",
  COMPLETED: "Uploaded",
} as const;
